import * as React from 'react';

import WorldHistory1750ToPresent from '../../../containers/WorldHistory1750ToPresent';
import AssignmentFlowNavigation from '../assignment_flow_navigation';
import { getPageTitle, WORLD_HISTORY_1750_TO_PRESENT_SLUG } from '../../../../Shared';


const AssignWorldHistory1750ToPresent = () => {
  document.title = getPageTitle("Assign", "Social Studies | World History 1750 to Present")
  return (
    <div>
      <AssignmentFlowNavigation courseSlug={WORLD_HISTORY_1750_TO_PRESENT_SLUG} />
      <WorldHistory1750ToPresent />
    </div>
  )
}

export default AssignWorldHistory1750ToPresent
